import { match as machine } from "../../../src/params/machine.ts";

export const matchers = { machine };